import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { Lookout } from "@/components/Lookout";
import { About } from "@/components/About";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <Header />
      <Hero />
      <Services />
      <Gallery />
      <Lookout />
      <About />
      <Booking />
      <Footer />
    </main>
  );
}
